import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import screen from 'superior-mq';
import { bp } from 'Styles/helpers';
import Container from '../container';
import { Link } from '../../routes';
import Waves from '../waves';

const FourOhFour = ({ statusCode }) => {
  const message = statusCode < 500 ? 'Page Not Found' : 'Server Error';

  return (
    <main>
      <Page>

        <Container>
          <h1>{statusCode} {message}</h1>
          {statusCode < 500 &&
            <p>
              The page you requested does not exist.<br />
              <Link href="/"><a>Return Home</a></Link>
            </p>
          }
        </Container>

        <Waves
          position="bottom"
          alignment="bottom"
          height={256}
          color="#073342"
        />

      </Page>
    </main>
  );
};

const Page = styled.section`
  display: flex;
  min-height: 100vh;
  position: relative;
  padding: 220px 0;

  ${screen.below(bp.portrait, `
    padding: 100px 0;
  `)}
`;

FourOhFour.propTypes = {
  statusCode: PropTypes.number,
};

FourOhFour.defaultProps = {
  statusCode: 404,
};

export default FourOhFour;
